import React, { memo } from 'react';

import classnames from 'classnames';

import { useWishlist } from '../../context/WishlistContext';

import './styles.scss';

function TagIcon() {
  return (
    <svg className="sidebar-nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
      />
    </svg>
  );
}

function HeartIcon() {
  return (
    <svg className="sidebar-nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
      />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg className="sidebar-nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
      />
    </svg>
  );
}

const NAV_ICONS = {
  shop: TagIcon,
  wishlist: HeartIcon,
  notifications: BellIcon,
};

export default memo(function Sidebar({
  activeView = 'shop',
  onNavigate,
}) {
  const { wishlist } = useWishlist();
  const wishlistCount = wishlist.length;

  const navItems = [
    { id: 'shop', label: 'Shop', icon: NAV_ICONS.shop },
    { id: 'wishlist', label: 'Wishlist', icon: NAV_ICONS.wishlist, badge: wishlistCount },
    { id: 'notifications', label: 'Notifications', icon: NAV_ICONS.notifications },
  ];

  return (
    <aside className="app-sidebar">
      <div className="sidebar-brand">
        <img
          src="/assets/logo.png"
          alt="Fortnite Dashboard"
          className="sidebar-logo"
        />
      </div>

      <nav className="sidebar-nav">
        {navItems.map(({ id, label, icon: Icon, badge }) => (
          <button
            key={id}
            type="button"
            className={classnames('sidebar-nav-item', { active: activeView === id })}
            onClick={() => onNavigate(id)}
          >
            <Icon />
            <span className="sidebar-nav-label">{label}</span>
            {badge > 0 && <span className="sidebar-nav-badge">{badge}</span>}
          </button>
        ))}
      </nav>
    </aside>
  );
});
